export default "__VITE_ASSET__DErTDFj0__"